export default (value) => {

    return this.$moment(value).format('Y');
}
